import * as z from 'zod';

// Types
import { TextZod } from '@/components/molecules/Text/TextType';
import { TagZod } from '@/types/TagType';
import { TitleZod } from '@/types/TitleType';
import { ParagraphZod } from '@/components/atoms/Paragraph/ParagraphType';

const JobDetailZod = z.object({
  id: z.number(),
  text: TextZod,
  withBlob: z.boolean(),
});

export type JobDetailType = z.infer<typeof JobDetailZod>;

const JobDetailsZod = z.object({
  __component: z.literal('block.job-details'),
  id: z.number(),
  jobDetails: z.array(JobDetailZod).nullable(),
  titleOverview: TitleZod,
  paragraphOverview: ParagraphZod,
  tags: z.array(TagZod).nullable(),
});

export type JobDetailsType = z.infer<typeof JobDetailsZod>;

export { JobDetailsZod, JobDetailZod };
